const state = {
 view_modal: false,
 log: {
  log_type: null,
  id: null,
  log_by: null,
  log_by_id: null,
  log_by_type: null,
  new_values: null,
  old_note_by: null,
  old_values: null,
  type: null,
  updated_at: null,
  worker_id: null,
  worker_model_id: null,
  worker_model_type: null,
  contact_id: null,
  contact_model_id: null,
  contact_model_type: null,
  client_id: null,
  client_model_id: null,
  client_model_type: null,
 },
 reload_logs: false
};

const actions = {};

const mutations = {
 SHOW_VIEW_LOG_MODAL(state, payload) {
  state.view_modal = true;
  state.log = {
   log_type: payload.log_type,
   id: payload.id,
   log_by: payload.log_by,
   log_by_id: payload.log_by_id,
   log_by_type: payload.log_by_type,
   new_values: payload.new_values,
   old_note_by: payload.old_note_by,
   old_values: payload.old_values,
   type: payload.type,
   updated_at: payload.updated_at,
   worker_id: payload.worker_id,
   worker_model_id: payload.worker_model_id,
   worker_model_type: payload.worker_model_type,
   contact_id: payload.contact_id,
   contact_model_id: payload.contact_model_id,
   contact_model_type: payload.contact_model_type,
   client_id: payload.client_id,
   client_model_id: payload.client_model_id,
   client_model_type: payload.client_model_type,
  }
 },
 HIDE_VIEW_LOG_MODAL(state) {
  state.view_modal = false;
  state.log = {
   log_type: null,
   id: null,
   log_by: null,
   log_by_id: null,
   log_by_type: null,
   new_values: null,
   old_note_by: null,
   old_values: null,
   type: null,
   updated_at: null,
   worker_id: null,
   worker_model_id: null,
   worker_model_type: null,
   contact_id: null,
   contact_model_id: null,
   contact_model_type: null,
   client_id: null,
   client_model_id: null,
   client_model_type: null,
  }
 },
 RELOAD_LOGS(state, payload) {
  state.reload_logs = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
